<mat-toolbar class="main-toolbar">
  <div class="toolbar-row">
    <a
      routerLink="/dashboard"
      class="brand"
      aria-label="RetireRight home"
    >
      <img
        class="logo"
        src="../../../../../assets/retireright_logo.svg"
        alt="AstraZeneca"
      />
      <span class="brand-name">RetireRight</span>
    </a>

    <nav class="application-nav" aria-label="Main navigation">
      <a
        routerLink="/demands"
        data-route="/demands"
        [class.active]="isActive('/demands')"
        [attr.aria-current]="isActive('/demands') ? 'page' : null"
      >
        My Demands
      </a>
      <a
        routerLink="/assignments"
        data-route="/assignments"
        [class.active]="isActive('/assignments')"
        [attr.aria-current]="isActive('/assignments') ? 'page' : null"
      >
        My Assignments
      </a>
    </nav>

    <div class="header-context">
      <img
        class="notification"
        src="../../../../../assets/notifications_none.svg"
        alt="Notification Center"
      />
      <span class="profile-name">
        {{ user()?.displayName || user()?.givenName || "Employee" }}
      </span>
      <img class="profile-image" [src]="profileImageUrl" alt="User profile" />
    </div>
  </div>
</mat-toolbar>
